export const riskProfiles = {

	categories : [],
	totalPoints : 0,
	pointsOK : false,
	categoriesRangesOK : [],
	categoriesRangesPointOK : false,

}
